<script setup>
import { computed, ref } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import { useToastStore } from "@/stores/toast.js";
import { useModalogStore } from "@/stores/modalog";
import { useApiService } from "@/services/useApiService";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

// Props
const props = defineProps({
    user: {
        type: Object,
        default: function () {
            return {};
        },
    },
});

// Services
const { unfollowUser } = useApiService();

// Composables
const { closeModalog } = useModalogStore();
const toastStore = useToastStore();

// State
const isSubmitting = ref(false);

// Computed
const isMyFollowersView = computed(() => {
    return ["Friends/Following", "Friends/Followers"].includes(
        usePage().component,
    );
});

// Methods
function confirmUnfollowUser() {
    isSubmitting.value = true;

    unfollowUser(props.user.uuid).then(() => {
        isSubmitting.value = false;
        closeModalog();
        toastStore.success(`You unfollowed @${props.user.username}.`);
        if (usePage().component === "Friends/FindFriends") {
            props.user.following = false;
        } else if (isMyFollowersView.value) {
            props.user.is_processing = true;
            props.user.is_processing_text = `Unfollowed @${props.user.username}`;
            router.reload({ only: ["following", "followers"] });
        } else {
            router.reload({ only: ["following", "followers", "users"] });
        }
    });
}
</script>

<template>
    <BrandConfirmModalog
        :title="`Unfollow ${user.full_name}`"
        confirm-label="Unfollow"
        busy-label="Unfollowing"
        danger
        :busy="isSubmitting"
        @confirm="confirmUnfollowUser"
    >
        <p>
            Please confirm you no longer wish to follow
            <strong>{{ user.full_name }} (@{{ user.username }})</strong>
        </p>
    </BrandConfirmModalog>
</template>
